import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_5 = { class: "d-sm-flex align-items-center" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 1,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
  type: "button",
  disabled: ""
}
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25 position-relative" }
const _hoisted_11 = {
  key: 0,
  class: "position-absolute w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-95",
  style: {"z-index":"1000","top":"0","left":"0","min-height":"100%","border-radius":"8px"}
}
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xm-12" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_22 = {
  key: 1,
  class: "table text-nowrap align-middle mb-0"
}
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_31 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_32 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_39 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_41 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_42 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_43 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_44 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_45 = { class: "text-danger fw-bold fs-14" }
const _hoisted_46 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddUsagerModal = _resolveComponent("AddUsagerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Mot clé ", -1)),
            _createVNode(_component_Field, {
              modelValue: _ctx.motCle,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.motCle) = $event)),
              name: "mot",
              type: "text",
              disabled: _ctx.isLoading,
              class: "form-control shadow-none fs-md-15 text-black",
              placeholder: "Recherche par mot clé"
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_ErrorMessage, {
              name: "mot",
              class: "text-danger"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.telecharger && _ctx.telecharger(...args))),
                disabled: _ctx.isLoading,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none",
                type: "button"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-download position-relative ms-5 fs-12" }, null, -1)),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Exporter"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, [...(_cache[6] || (_cache[6] = [
                      _createElementVNode("span", {
                        class: "spinner-grow spinner-grow-sm me-2",
                        role: "status",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createTextVNode(" Export en cours... ", -1)
                    ]))]))
              ], 8, _hoisted_6))
            : _createCommentVNode("", true),
          (!_ctx.valideEtape3)
            ? (_openBlock(), _createElementBlock("button", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("span", {
                  class: "spinner-grow spinner-grow-sm",
                  role: "status",
                  "aria-hidden": "true"
                }, null, -1),
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "text-center" }, [
                _createElementVNode("div", {
                  class: "spinner-border text-primary mb-3",
                  role: "status",
                  style: {"width":"3rem","height":"3rem"}
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ]),
                _createElementVNode("h5", { class: "text-muted mb-2" }, "Chargement des données..."),
                _createElementVNode("p", { class: "text-muted small" }, "Veuillez patienter pendant que nous récupérons les informations.")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Marches ", -1)),
                _createVNode(_component_Field, {
                  name: "marche",
                  modelValue: _ctx.marches,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.marches) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      mode: "tags",
                      options: _ctx.marcheOptions,
                      searchable: true
                    }, field, {
                      placeholder: "Sélectionner un marché",
                      disabled: _ctx.isLoading
                    }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Secteur ", -1)),
                _createVNode(_component_Field, {
                  name: "secteur",
                  modelValue: _ctx.secteurs,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.secteurs) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      mode: "tags",
                      options: _ctx.secteursOptions,
                      searchable: true
                    }, field, {
                      placeholder: "Sélectionner un secteur",
                      disabled: _ctx.isLoading
                    }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "secteur",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Etats ", -1)),
                _createVNode(_component_Field, {
                  name: "etat",
                  modelValue: _ctx.etat,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.etat) = $event))
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.etatOptions,
                      searchable: true
                    }, field, {
                      placeholder: "Sélectionner un état",
                      disabled: _ctx.isLoading
                    }), null, 16, ["options", "disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "etat",
                  class: "text-danger"
                })
              ])
            ])
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_20, [
          (!_ctx.isLoading && _ctx.usagers.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[13] || (_cache[13] = [
                _createElementVNode("div", { class: "mb-3" }, [
                  _createElementVNode("i", {
                    class: "fas fa-search text-muted",
                    style: {"font-size":"3rem"}
                  })
                ], -1),
                _createElementVNode("h5", { class: "text-muted mb-2" }, "Aucune donnée trouvée", -1),
                _createElementVNode("p", { class: "text-muted" }, "Aucun emplacement ne correspond à vos critères de recherche.", -1)
              ]))]))
            : (_openBlock(), _createElementBlock("table", _hoisted_22, [
                _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " A Code "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " N Code "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Type Place "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Matricule Loc "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Locataire "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Categorie Activite Loc "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Activite Loc "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Détail Activite Exp "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Matricule Exp "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Exploitant "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Categorie Activite Exp "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Activite Exp "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Détail Activite Exp "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Catégorie Activite Place "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Activite Place "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Etat "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Encours Payés "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Encours Dû "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Arrièrés Payés "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Arrièrés Dû "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Total Payé "),
                    _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                    }, " Dette Totale ")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usagers, (emp, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_23, _toDisplayString(emp.emplacement_codeemp), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(emp.emplacement_ncode_emp), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(emp.type_emplacement_libelle_type_emp), 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(emp.locataire_matricule), 1),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(emp.locataire_full_name), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.afficher20Caracteres(emp.locataire_activite)), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.afficher20Caracteres(emp.locataire_new_activite)), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.afficher20Caracteres(emp.locataire_nouveau_activite)), 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(emp.exploitant_matricule), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(emp.exploitant_full_name), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.afficher20Caracteres(emp.exploitant_activite)), 1),
                      _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.afficher20Caracteres(emp.exploitant_new_activite)), 1),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.afficher20Caracteres(emp.exploitant_nouveau_activite)), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.afficher20Caracteres(emp.activite_activite_nom)), 1),
                      _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.afficher20Caracteres(emp.activite_activite_nom)), 1),
                      _createElementVNode("td", _hoisted_38, _toDisplayString((parseFloat(emp.totalAPayer)) > 0 ? "Endetté" : "A jour"), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.separateur((parseFloat(emp.totalPayeEncours)))), 1),
                      _createElementVNode("td", _hoisted_40, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.separateur(parseFloat(emp.resteAPayerEncours))), 1)
                      ]),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.separateur((parseFloat(emp.totalPayeEncours)) )), 1),
                      _createElementVNode("td", _hoisted_42, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.separateur((parseFloat(emp.totalArrieres)) )), 1)
                      ]),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.separateur((parseFloat(emp.totalPayeEncours) + (parseFloat(emp.totalPayeEncours)) ) )), 1),
                      _createElementVNode("td", _hoisted_44, [
                        _createElementVNode("b", _hoisted_45, _toDisplayString(_ctx.separateur((parseFloat(emp.totalAPayer)) )), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddUsagerModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onOpen: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onOpen"])
  ], 64))
}